import { render, staticRenderFns } from "./KaoQing.vue?vue&type=template&id=5b7a809b&scoped=true"
import script from "./KaoQing.vue?vue&type=script&lang=js"
export * from "./KaoQing.vue?vue&type=script&lang=js"
import style0 from "./KaoQing.vue?vue&type=style&index=0&id=5b7a809b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7a809b",
  null
  
)

export default component.exports